export const USER_EMAIL_LOGIN_REQUEST = 'USER_EMAIL_LOGIN_REQUEST'
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS'
export const USER_EMAIL_LOGIN_FAIL = 'USER_EMAIL_LOGIN_FAIL'
export const USER_GOOGLE_LOGIN_REQUEST = 'USER_GOOGLE_LOGIN_REQUEST'
export const USER_GOOGLE_LOGIN_FAIL = 'USER_GOOGLE_LOGIN_FAIL'
export const USER_LOGOUT = 'USER_LOGOUT'

export const USER_REGISTER_REQUEST = 'USER_REGISTER_REQUEST'
export const USER_REGISTER_SUCCESS = 'USER_REGISTER_SUCCESS'
export const USER_REGISTER_FAIL = 'USER_REGISTER_FAIL'

export const CURRENT_USER_DETAILS_REQUEST = 'CURRENT_USER_DETAILS_REQUEST'
export const CURRENT_USER_DETAILS_SUCCESS = 'CURRENT_USER_DETAILS_SUCCESS'
export const CURRENT_USER_DETAILS_NOTFOUND = 'CURRENT_USER_DETAILS_NOTFOUND'
export const CURRENT_USER_DETAILS_FAIL = 'CURRENT_USER_DETAILS_FAIL'
export const CURRENT_USER_DETAILS_RESET = 'CURRENT_USER_DETAILS_RESET'

export const CURRENT_USER_DATA_REQUEST = 'CURRENT_USER_DATA_REQUEST'
export const CURRENT_USER_DATA_SUCCESS = 'CURRENT_USER_DATA_SUCCESS'
export const CURRENT_USER_DATA_FAIL = 'CURRENT_USER_DATA_FAIL'
export const CURRENT_USER_DATA_RESET = 'CURRENT_USER_DATA_RESET'

export const UPLOAD_IMAGE_REQUEST = 'UPLOAD_IMAGE_REQUEST'
export const UPLOAD_IMAGE_SUCCESS = 'UPLOAD_IMAGE_SUCCESS'
export const UPLOAD_IMAGE_FAIL = 'UPLOAD_IMAGE_FAIL'
export const UPLOAD_IMAGE_RESET = 'UPLOAD_IMAGE_RESET'

export const VERIFICATION_LINK_REQUEST = 'VERIFICATION_LINK_REQUEST'
export const VERIFICATION_LINK_SUCCESS = 'VERIFICATION_LINK_SUCCESS'
export const VERIFICATION_LINK_FAIL = 'VERIFICATION_LINK_FAIL'

export const PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST'
export const PASSWORD_RESET_SUCCESS = 'PASSWORD_RESET_SUCCESS'
export const PASSWORD_RESET_FAIL = 'PASSWORD_RESET_FAIL'

export const FETCH_USER_DETAILS_BY_ID_REQUEST = 'FETCH_USER_DETAILS_BY_ID_REQUEST'
export const FETCH_USER_DETAILS_BY_ID_SUCCESS = 'FETCH_USER_DETAILS_BY_ID_SUCCESS'
export const FETCH_USER_DETAILS_BY_ID_FAIL = 'FETCH_USER_DETAILS_BY_ID_FAIL'
export const FETCH_USER_DETAILS_BY_ID_RESET = 'FETCH_USER_DETAILS_BY_ID_RESET'

export const UPDATE_USER_DETAILS_REQUEST = 'UPDATE_USER_DETAILS_REQUEST'
export const UPDATE_USER_DETAILS_SUCCESS = 'UPDATE_USER_DETAILS_SUCCESS'
export const UPDATE_USER_DETAILS_FAIL = 'UPDATE_USER_DETAILS_FAIL'
export const UPDATE_USER_DETAILS_RESET = 'UPDATE_USER_DETAILS_RESET'